/* eslint-disable @typescript-eslint/restrict-plus-operands */
import type { EventsForFuelAnalyticsInterface } from 'utils/fuelAnalytics';
import type { AssetFuelConsumption } from 'store/planningAid.slice';
export function formatFuelResponses(
  responses: any[],
  eventsForFuelAnalytics: EventsForFuelAnalyticsInterface[]
) {
  const deviceMap: Record<string, AssetFuelConsumption> = {};

  responses.forEach((response, index) => {
    if (response.status !== 'fulfilled') return;

    const eventKey = eventsForFuelAnalytics[index].key;
    const items = response.value?.Items?.Items;

    if (!Array.isArray(items)) return;

    for (const item of items) {
      const { device_id: deviceId, fuel_used: fuelUsed } = item;
      if (!deviceId) continue;

      if (!deviceMap[deviceId]) {
        deviceMap[deviceId] = { device: deviceId };
      }

      deviceMap[deviceId][eventKey] =
        (deviceMap[deviceId][eventKey] ?? 0) + fuelUsed;
    }
  });

  return Object.values(deviceMap);
}
